import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Préparer chaque cours vous demande énormément de temps',
  description: 'Chaque semaine, vous passez des heures à préparer vos séances. Vous cherchez de nouveaux exercices, créez des progressions, imaginez des chorégraphies et adaptez les activités. Au final, préparer vos cours prend presque autant de temps que les enseigner.'
}, {
  emoji: '⚠️',
  title: 'Vous ne savez pas toujours quoi enseigner ensuite',
  description: "Quel exercice proposer aujourd'hui ? Mes élèves sont-ils prêts ? Comment faire évoluer un groupe de niveaux différents ? Construire des cours variés, progressifs et motivants devient un véritable défi semaine après semaine."
}, {
  emoji: '📚',
  title: 'Vos ressources pédagogiques sont dispersées partout',
  description: "Exercices, chorégraphies, échauffements... Tout existe, mais tout est éparpillé entre livres, formations, PDF, YouTube et des dizaines de dossiers. Rien n'est organisé dans un système unique facile à utiliser."
}, {
  emoji: '😩',
  title: 'La préparation finit par devenir épuisante',
  description: "Entre la préparation, les chorégraphies, l'adaptation des exercices et les spectacles, il reste très peu de temps pour ce qui compte vraiment : accompagner vos élèves et transmettre votre passion."
}];
export function PainSection() {
  return <section className="py-8 px-4 sm:px-6 bg-brand-cream" data-id="element-102">
      <h2 className="text-2xl sm:text-3xl font-heading font-bold text-center text-brand-title mb-2 uppercase leading-tight" data-id="element-103">
        VOUS VOUS RECONNAISSEZ ?
      </h2>

      <p className="text-sm sm:text-base text-brand-text font-medium text-center mb-6 leading-relaxed max-w-xl mx-auto" data-id="element-104">
        Vous adorez enseigner la danse. Mais préparer chaque cours finit par
        vous prendre une grande partie de votre semaine.
        <br className="hidden sm:block" data-id="element-105" />
        <span className="text-brand-rose font-bold mt-2 block" data-id="element-106">
          Si vous enseignez dans une école, une association ou en cours
          particuliers, vous avez probablement déjà vécu ceci :
        </span>
      </p>

      <div className="flex flex-col gap-3" data-id="element-107">
        {pains.map((pain, i) => <div key={i} className="bg-white p-4 rounded-lg border-l-4 border-brand-rose shadow-sm flex gap-4 items-start" data-id="element-108">
            <div className="text-2xl leading-none shrink-0 mt-0.5" data-id="element-109">
              {pain.emoji}
            </div>
            <div data-id="element-110">
              <h3 className="text-base font-bold text-brand-title mb-1 uppercase tracking-tight" data-id="element-111">
                {pain.title}
              </h3>
              <p className="text-brand-text text-sm font-medium leading-relaxed" data-id="element-112">
                {pain.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}